'use client';

import { toast } from 'react-toastify';
import { Alert, Box, Typography } from '@mui/material';

// import { sendEmailVerificationLink } from '@/services/firebase';
import { MESSAGES, ROUTES } from '@/constants';

export interface AuthModalErrorAlertProps {
  error: string | null;
  onClose: () => void;
}

export function AuthModalErrorAlert({ error, onClose }: AuthModalErrorAlertProps) {
  if (!error) return null;

  const isUnverified = error === MESSAGES.AUTH.EMAIL_UNVERIFIED;

  const handleResend = async () => {
    try {
      // await sendEmailVerificationLink(ROUTES.VERIFY_EMAIL);
      toast.info(MESSAGES.TOAST.VERIFICATION_RESEND_HANDLED);
      // toast.success(MESSAGES.AUTH.VERIFICATION_EMAIL_SENT);
    } catch (err) {
      toast.error(MESSAGES.AUTH.RESEND_VERIFICATION_LINK_FAILED);
    }
  };

  return (
    <Alert
      severity="error"
      sx={{
        mb: 1.5,
        fontSize: '0.8125rem',
        '& .MuiAlert-message': {
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
        },
      }}
      onClose={onClose}
    >
      <Box>{error}</Box>
      {isUnverified && (
        <Typography
          component="button"
          onClick={handleResend}
          sx={{
            color: 'inherit',
            background: 'none',
            border: 'none',
            p: 0,
            cursor: 'pointer',
            fontSize: '0.75rem',
            fontWeight: 600,
            textDecoration: 'underline',
            alignSelf: 'flex-start',
            mt: 0.5,
            '&:hover': {
              opacity: 0.8,
            },
          }}
        >
          Resend Verification Link
        </Typography>
      )}
    </Alert>
  );
}
